export default class FocusNext
{
    constructor($el, options = {}) {
        this.DOM = { $el }
        this.options = { ...FocusNext.prototype.defaults, ...options }
        this.init()
    }

    init() {
        this.length = this.DOM.$el.dataset[this.options.attrLength]
        this.selector = this.DOM.$el.dataset[this.options.attrSelector]

        if (this.selector) {
            this.DOM.$next = document.querySelector(this.selector)

            if (this.DOM.$next) {
                this.DOM.$el.addEventListener('keyup', this.onKeyUp.bind(this))
            }
        }
    }

    onKeyUp(e) {
        if (['Shift', 'Tab'].indexOf(e.key) === -1) {
            if (this.DOM.$el.value.length == this.length) {
                this.DOM.$next.focus()
            }
        }
    }
}

FocusNext.prototype.defaults = {
    attrLength: 'focusNextLength',
    attrSelector: 'focusNextSelector',
}